export default __webpack_public_path__ + "static/media/teams-3.687793b2.jpg";